module.exports = __webpack_public_path__ + "u-me.c610969b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/u-me.svg
// module id = Jlzl
// module chunks = 0